(function ($, Global) {
	var BtnMoreArticlesComponent = function (model) {
		this.model = model;
	}

	BtnMoreArticlesComponent.prototype.initEvents = function () {
		this.publishers();
	}

	BtnMoreArticlesComponent.prototype.publishers = function () {
		var self = this;

		$(document).on('click', '.btn-more-articles', function () {
			var $this = $(this);
            var $page = $this.closest('.page');
            var $idPublication = $this.attr("data-publication");
            var currentScroll = $(window).scrollTop();

			var data = {};

			if ($this.closest('.list-articles-hidden').exists()) {
				var $parent = $this.closest('.list-articles-hidden');

				$parent.replaceClass('list-articles-hidden', 'list-articles-show');
				return;
            }

            if ($this.closest('.page').exists()) {
                $.Topic('loader-show').publish($page);
            } else {
                $.Topic('loader-show').publish($this.closest('.list-articles'));
            }

			self.model.pagination += 1;
			data = {
		        RequestedPage: self.model.pagination,
		        ListType: 'ListeArticle',
		        NombreDeResultatsParPage: 15,
                IsExcludeHomeArticles: true,
		        Publication: [$idPublication]
		    }

		    self.model.getAllResults(data, function (data) {
				$('div.last-articles').append(data.data.html);
                $this[!data.data.hasMoreResults ? 'addClass' : 'removeClass']('hidden');
                $(window).scrollTop(currentScroll);
			});
		});
	}

	Global.BtnMoreArticlesComponent = BtnMoreArticlesComponent;
}(jQuery, window));